import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchProductSync } from '../redux/PerformanceReducer/Ecommerce/productSyncSlice';
import { selectIsMultiStoreEnabled, selectUserDetails } from '../redux/UserReducer/userSlice';
import { getEffectiveStoreNumber } from '../utils/appUtils';

export const useProductSyncData = (): void => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(selectUserDetails);
  const isMultiStoreEnabled = useAppSelector(selectIsMultiStoreEnabled);

  const effectiveStoreNumber = useMemo(
    () => getEffectiveStoreNumber(userDetails, isMultiStoreEnabled),
    [userDetails, isMultiStoreEnabled],
  );

  useEffect(() => {
    if (!effectiveStoreNumber) return;
    dispatch(
      fetchProductSync({
        storeNumber: effectiveStoreNumber,
        isMultiStoreMode: isMultiStoreEnabled,
      }),
    );
  }, [dispatch, effectiveStoreNumber, isMultiStoreEnabled]);
};
